<app-nav-cliente></app-nav-cliente>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-6">
            <div class="row">
                <div class="col-lg-5">
                    <div *ngIf="perfil.imagen == '';  else sihay">
                        <img src="assets/img/auri.png" width="100%">
                    </div>
                    <ng-template #sihay>
                        <img src="{{environment}}{{perfil.imagen}}" width="100%">
                    </ng-template>
                    Actualizar Foto:<br>
                    <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>
                    <button class=" negro border0 input60 fondoAmarillo" (click)="updateProfile();">Actualizar</button>
                    <br><br>
                </div>
                <div class="col-lg-5">
                    <br><br>
                    <p><strong>{{perfil.nombre}}</strong><br>
                        {{perfil.celular}}<br>
                        {{perfil.email}}<br>
                        {{perfil.grupo}}<br>
                        {{perfil.carrera}}<br>
                    </p>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <app-mi-paquete></app-mi-paquete>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>